module.exports = function ($state, $timeout, $location, specialsGroupsService, breakpointsService, hyphenate, moveFocus) {
    return {
        restrict: 'E',
        scope: true,
        link(scope, element) {

            function isScrolledIntoView($el) {
                const el = $el[0];
                const elemTop = el.getBoundingClientRect().top;
                const elemBottom = el.getBoundingClientRect().bottom;
                const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
                return isVisible;
            }

            const scroller = element.find('.hideScroll-wrapper');
            scroller.on('scrollstop', function () {
                if (scope.openGroup) {
                    scope.showClone = !isScrolledIntoView(element.find('.specialsGroups-link:not(.is-closed)'));
                    scope.$apply();
                }
            });
//
//            scope.cloneClick = function () {
//                const openLink = element.find('.specialsGroups-specialGroup:not(.is-clone) .specialsGroups-link');
//                scrollToElement(openLink, 0, '0.4s', -80);
//            };

            scope.isSmallFormat = function () {
                return breakpointsService.isSmallFormat();
            };

            scope.specialsGroupsService = specialsGroupsService;

            scope.toggleGroup = function (specialsGroup) {

                // We don't want to do any of this behaviour out of small format.
                if (!breakpointsService.isSmallFormat()) {
                    moveFocus('#center-panel');
                    return;
                }
                scope.openGroup = scope.openGroup === specialsGroup ? null : specialsGroup;
            };

            scope.isActive = function (groupName) {
                return $state.params.specialGroup === hyphenate(groupName);
            };

            function update(updateUrl) {
                specialsGroupsService.listGroups().then(function (groups) {
                    scope.specialsGroups = groups;
                    if (updateUrl && !breakpointsService.isInSmallFormat) {
                        specialsGroupsService.updateUrl();
                        //Check if the current group from state params exists
                        const selectedGroup = specialsGroupsService.findSpecialsGroup(groups, $state.params.specialGroup);
                        if (selectedGroup) {
                            /*After introducing auto generated specials groups in skyblue, we will need to refresh the special groups based on current area.
                            Because, the same special group can exists for different fulfilment stores. So, special group name will be the same, But ID will be different for
                            different areas. whene ever the area is changed, we need to update the selectedGroup as below to get the right products for a particular area.*/
                            specialsGroupsService.selectedGroup = selectedGroup;
                        }
                        const shouldGoToFirstSpecialGroup = !selectedGroup && $state.includes('shop.specials.groups');
                        if (shouldGoToFirstSpecialGroup) {
                            specialsGroupsService.firstSpecialsGroupUrl();
                        }
                    }
                    $timeout(function () {
                        scope.openGroup = specialsGroupsService.selectedGroup;
                    });
                });
            }

            function init() {
                specialsGroupsService.invalidateSpecialGroups();
                update(true);
            }

            function updateHandler() {
                update(true);
            }

            scope.$watch(function () {
                return $state.params.specialGroup;
            }, function (specialGroupName) {
                specialsGroupsService.selectGroupByName(specialGroupName);
            });

            scope.$on('address-update', updateHandler);
            scope.$on('login:success', function () {
                specialsGroupsService.invalidateSpecialGroups();
                updateHandler();
            });

            init();
        },
        template: require('./specials-groups-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/specials/specials-groups-directive.js
 **/